export const defaultCurrency = {
  value: 0,
  code: 'USD',
};
